import React from "react";
import { motion } from "framer-motion";
import { 
  DollarSign, FileCheck, Factory, Truck, 
  Link2, Users, Globe, Award 
} from "lucide-react";
import { Card, CardContent } from "../ui/card";

export default function ValueCreation() {
  const valueDrivers = [
    {
      icon: DollarSign,
      title: "Working Capital & Growth Finance",
      description: "Bridge orders, inventory, and receivables to unlock scale"
    },
    {
      icon: FileCheck,
      title: "Public Funding & Grants",
      description: "EU & national opportunity mapping, consortium building, compliance & reporting"
    },
    {
      icon: Factory,
      title: "Production Scaling",
      description: "New lines, automation, DfM/DfA, ITAR/EU certifications"
    },
    {
      icon: Truck,
      title: "Defence Logistics Enablement",
      description: "Field logistics, deployment planning, fleet availability, expeditionary support"
    },
    {
      icon: Link2,
      title: "Supply Chain Optimization",
      description: "Vendor development, long-lead mitigation, strategic sourcing"
    },
    {
      icon: Users,
      title: "Organizational Build-Out",
      description: "Leadership hiring, governance, board cadence, OKRs"
    },
    {
      icon: Globe,
      title: "Go-to-Market & JVs",
      description: "Tier-1 access, primes/OEM onboarding, offset programs"
    },
    {
      icon: Award,
      title: "Internationalization",
      description: "EU/Middle East channels, licensing, co-production"
    }
  ];

  return (
    <div className="bg-[#F5F7FA] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C3E50] mb-6">
            How We Create Value
          </h2>
          <p className="text-xl text-[#6B7C93] max-w-3xl mx-auto">
            We go beyond providing growth capital — we unlock scale by actively supporting portfolio companies with strategic insight, industry access, operational know-how, and hands-on partnership across every stage of growth.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {valueDrivers.map((driver, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
            >
              <Card className="bg-white border-none shadow-md hover:shadow-xl transition-all duration-300 h-full group">
                <CardContent className="p-6">
                  <div className="bg-gradient-to-br from-[#24A19C]/10 to-[#E0B422]/10 p-4 rounded-xl w-fit mb-4 group-hover:from-[#24A19C]/20 group-hover:to-[#E0B422]/20 transition-colors">
                    <driver.icon className="w-6 h-6 text-[#24A19C]" />
                  </div>
                  <h3 className="text-lg font-bold text-[#2C3E50] mb-2">
                    {driver.title}
                  </h3>
                  <p className="text-sm text-[#6B7C93] leading-relaxed">
                    {driver.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}